"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FooterCopyright() {
  return /*#__PURE__*/_react.default.createElement("div", null, "Copyright \xA9", ' ', new Date().getFullYear(), ' ', "Advisr Inc. and/or its affiliates. All rights reserved.", /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/"
  }, "Privacy policy"), /*#__PURE__*/_react.default.createElement("a", {
    href: "/"
  }, "Imprint")));
}

var _default = FooterCopyright;
exports.default = _default;